import React from "react";
import ServiceAreaOneMultiImg from "./ServiceAreaOneMultiImg";
import { MANTENIMIENTO_SERVICES_DATA } from "../data/mantenimientoData";

// Icon mapping (default icons for services)
const defaultIcons = [
  "../assets/img/icon/service-icon_1-1.svg",
  "../assets/img/icon/process-icon-1-1.svg",
  "../assets/img/icon/wcu-icon_2-3.svg",
  "../assets/img/icon/wcu-icon_2-6.svg",
  "../assets/img/icon/service-icon_1-6.svg",
];

// Transform data from mantenimientoData.js to the format expected by ServiceAreaOneMultiImg
const servicesData = MANTENIMIENTO_SERVICES_DATA.map((service, index) => ({
  icon: defaultIcons[index % defaultIcons.length],
  title: service.title,
  text: service.description.split('\n')[0].trim(), // First paragraph as summary
  link: `/mantenimiento/${service.slug}`,
  image: service.images?.[0] || "../assets/img/service/service-1-3.png",
  altIcon: `Icono ${service.title}`,
  altImage: `Imagen ${service.title}`,
}));

const MantenimientoServicesData = ({title}) => {
  return (
    <ServiceAreaOneMultiImg      
       categoryService={title}
    services={servicesData} 
    />
  );
};

export default MantenimientoServicesData;
